import React from "react";
import "../css/RejectModal.css";
import { CircularProgress } from "@mui/material";
import { REJECT_REASONS } from "../../utils/constants";

const RejectModal = ({
  selectedReason,
  onReasonChange,
  onRejectClick,
  isLoading,
}) => {
  return (
    <div className="reject-modal-content">
      <h2 className="reject-modal-title">Reject</h2>
      <p className="reject-modal-description">Select a reason to reject</p>
      <form onSubmit={onRejectClick} className="reject-modal-form">
        {REJECT_REASONS.map((reason, index) => (
          <div key={index} className="reject-radio-container">
            <input
              type="radio"
              id={`reason-${index}`}
              name="reject-reason"
              value={reason.value}
              checked={selectedReason === reason.value}
              onChange={onReasonChange}
              className="reject-radio-input"
            />
            <label htmlFor={`reason-${index}`} className="reject-radio-label">
              {reason.label}
            </label>
          </div>
        ))}
        <button className="reject-button">
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Reject"
          )}
        </button>
      </form>
    </div>
  );
};

export default RejectModal;
